import { bounded, ANALYSIS_TIMEOUTS, AnalysisError } from "../utils/analysis-async";
import { AnalysisRun, AnalysisRunService } from "../services/analysis-run.service";
import { IAnalyzer } from "../interfaces/analyzer";
import { AnalysisResult } from "../models/analysis-result";
import { HttpClient } from "@angular/common/http";
import { ConfigService } from "../services/config.service";
import { RiskLevel } from "../models/risk-level";
import { IAnalyzerConfig } from "../interfaces/analyzer-config";
import { MailUtils } from "../utils/mail.utils";
import { LogService } from "../services/log.service";
import { Inject, Injector } from "@angular/core";
import { DomainService } from "../services/domain.service";
import { Constants } from "../models/shared.model";
import { ANALYZERS } from "../models/constants";
import { TranslateService } from "@ngx-translate/core";

export class DomainAgeAnalyzer implements IAnalyzer {
    private readonly run: AnalysisRun;

  private configService: ConfigService;
  private domainService: DomainService;
  private log: LogService;
  private http: HttpClient;
  private translate: TranslateService;

  constructor(
    @Inject(Injector) private injector: Injector
  ) {
        this.run = this.injector.get(AnalysisRunService).current;
    this.configService = this.injector.get(ConfigService);
    this.domainService = this.injector.get(DomainService);
    this.log = this.injector.get(LogService);
    this.http = this.injector.get(HttpClient);
    this.translate = this.injector.get(TranslateService);
  }

  async runAnalysis(domain?: string): Promise<AnalysisResult> {
    this.run.assertActive();
    const config = this.configService.getAnalyzerConfiguration(ANALYZERS.DOMAIN_AGE);
    domain = domain || MailUtils.parseMultiLevelDomain(this.run.item.sender.emailAddress);
    const registeredDate = await bounded(() => this.domainService.getDomainRegisteredDate(domain),
      ANALYSIS_TIMEOUTS.graph, 'Domain age', this.run);
    this.run.assertActive();
    if (registeredDate == null) throw new AnalysisError('unavailable', 'Domain registration date unavailable');
    const age = this.domainService.calculateDomainAge(registeredDate);
    const level = age.months <= config.thresholds.high ? RiskLevel.High : RiskLevel.Low;
    const info = this.translate.instant(level === RiskLevel.High ? 'analyzer.domain_age_below_threshold' :
      'analyzer.domain_age_above_threshold', { domainAge: age.months, threshold: config.thresholds.high });
    return new AnalysisResult(config.displayName, level, config.weight, config.description!, {
      domainAge: age.formattedDate, isDomainNew: level === RiskLevel.High, domainCreatedAt: registeredDate, info
    });
  }
}
